import { Typography, Button } from "@mui/material";
import { tss } from "tss-react";
import { api } from "api/Call";
import ModalWindow from "components/ModalWindow";
import { config } from "config";
import EventsEmitter from "events/EventsEmitter";
import { updateData } from "services/CacheService";

const useStyles = tss.create(() => ({
    title: {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 20,
    },
    confirmationText: {
        fontSize: 14,
        marginBottom: 20,
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        marginLeft: 5,
        width: 75,
        height: 36,
    },
    bottom: {
        position: "absolute",
        top: "calc(100% - 49px)",
        right: 22,
    },
    nextButton: {
        color: "red",
        fontWeight: "bold",
    },
    cancelButton: {
        right: 14,
        fontWeight: "bold",
    },
}));

type IProps = {
    open: boolean;
    catalog: any;
    version: string;
    product: string;
    handleClose: (cancelled: boolean) => void;
};

export default function ActivateVersionPanel(props: IProps) {
    const { classes } = useStyles();
    const { version, product, catalog, open } = props;
    const projectId = catalog?.project;

    const handleCancel = () => {
        props.handleClose(false);
    };

    const handleOk = () => {
        sendData();
        props.handleClose(true);
    };

    function sendData() {
        const body_product = {
            version_active: version,
        };
        const body_version = {
            version_active_date: new Date().valueOf() + "",
        };
        api(`${config.api.endpoints["entity"]}?id=` + product + "&project=" + projectId, { body: body_product })
            .then((entries: any) => {})
            .catch((error: any) => {});
        api(`${config.api.endpoints["entity"]}?id=` + version + "&project=" + projectId, { body: body_version })
            .then((entries: any) => {})
            .catch((error: any) => {});
        const entity = catalog.entity;
        if (entity) {
            console.log("setActiveVersion to:", version);
            entity["version_active"] = version;
            updateData("update", "entities", projectId, entity);
            EventsEmitter.emit("signalr_update", {
                type: "entity_update",
                action: "reload_all",
            });
        }
    }

    return (
        <ModalWindow handleClose={handleCancel} width={500} height={200} minHeight={"fit-content"} open={open}>
            <Typography className={classes.title}>Set Version as Active</Typography>
            <Typography className={classes.confirmationText}>
                This will set this version as active and it will be used by any future processing. Are you sure you want
                to proceed?
            </Typography>
            <div className={classes.bottom}>
                <Button
                    onClick={(e) => {
                        handleCancel();
                    }}
                    className={[classes.button, classes.cancelButton].join(" ")}
                >
                    No
                </Button>
                <Button
                    onClick={(e) => {
                        handleOk();
                    }}
                    className={[classes.button, classes.nextButton].join(" ")}
                >
                    Yes
                </Button>
            </div>
        </ModalWindow>
    );
}
